import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class RouterExtService {
    public routerUrls: any[] = [];
    private previousUrl: string | null = null;
    private currentUrl: string | null = null;

    constructor(private router: Router) {}

    public init(): void {
        this.router.events
            .pipe(
                filter((event) => {
                    return event instanceof NavigationEnd;
                }),
                map((event) => event as NavigationEnd),
            )
            .subscribe({
                next: (navigationEnd: NavigationEnd) => {
                    this.previousUrl = this.currentUrl;
                    this.currentUrl = navigationEnd.url;
                },
            });
    }

    public getPreviousUrl(): string | null {
        return this.previousUrl;
    }
}
